import {
  Button,
  FormControlLabel,
  Grid,
  Switch,
  Typography,
  WithStyles,
  withStyles,
} from "@material-ui/core";
import { bindActionCreators } from "@reduxjs/toolkit";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { MyPATDialog } from "../../../../../common";
import { contentManagementAction } from "../../../../reducers/contentMangementData";
import { courseStyles } from "../../../../styles";
import _ from "lodash";
import { courseManagementActions } from "../../../../reducers/courseManagementReducer";
import { defaultDisplaySetting } from "../../../treeComponents/component/helpers/preSelectedFilters";

interface Props extends WithStyles<typeof courseStyles> {
  onClose: () => void;
  // classes: any;
  
}

interface State {
  displaySettings: any;
}

interface Props {
  classes: any;
  treeData: any;
  setTreeData: Function;
  open:boolean
}

class CourseSettingPopUp extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      displaySettings: defaultDisplaySetting
    };
  }
  componentDidMount(){
      const {treeData}=this.props;
      const {displaySettings}=treeData;
      this.setState({displaySettings:displaySettings});
  } 
  componentDidUpdate(prevProps:Props,prevState:State){
    if(prevProps.treeData!=this.props.treeData){
        this.setState({displaySettings:this.props.treeData.displaySettings});
    }
  }
  onSave = () => {
    const { displaySettings } = this.state;
    const { treeData, setTreeData,onClose } = this.props;
    const cloneTree = { ...treeData };
    cloneTree.displaySettings = displaySettings;
    setTreeData({ treeData: cloneTree });
    onClose();
    
  };

  toggleSet = (key: string) => {
    const { displaySettings } = this.state;
    const newDisplaySettings = { ...displaySettings };
    newDisplaySettings[key] = !newDisplaySettings[key];
    this.setState({ displaySettings: newDisplaySettings });
  };

  render() {
    const { onClose, classes, open } = this.props;
    const labels: string[] = ["Phase", "Week", "Chapter", "Concept"];
    const { displaySettings } = this.state;
    return (
      <MyPATDialog
        dialogOpen={open}
        dialogHasActions={false}
        onDialogClose={onClose}
        dialogHeading={
          <>
            <Typography
              style={{ textAlign: "center" }}
              className={classes.font24}
            >
              Course Plan Setting
            </Typography>
          </>
        }
        isAlignCenter={false}
        variantHeader="leftHeader"
        customButtonVariant="withoutBorderCloseIcon"
        isCustomBackground={false} //Check
        isborderDialogAction={false}
        // otherDialogProps={{
        //     fullWidth: false,
        //   }}
        // customDialogActions={}
      >
        <Typography>Show the following in Course Plan</Typography>
        <Grid className={classes.radioContainer}>
          {labels.map((item) => {
            return (
              <FormControlLabel
                className={classes.updateLabel}
                control={
                  <Switch
                    classes={{
                      root: classes.swithMain,
                      icon: classes.switchIcon,
                      bar: classes.switchBar,
                      iconChecked: classes.IscheckedSwitch,
                      checked: classes.checkedSwitch,
                    }}
                    color="primary"
                    checked={displaySettings["show" + item + "s"]}
                    onChange={() => this.toggleSet("show" + item + "s")}
                    disabled={item == "Phase"}
                  />
                }
                label={item}
                labelPlacement="start"
              />
            );
          })}
          <Button variant="contained" color="primary" onClick={this.onSave}>
            Save
          </Button>
        </Grid>
      </MyPATDialog>
    );
  }
}

const mapStateToProps = (state: any) => ({
  treeData: _.get( state,"courseMangementData.contentManagementData.treeData",{}),
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setTreeData: contentManagementAction.setTreeData,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(courseStyles)(withRouter(CourseSettingPopUp)));

